<mat-card>
  <mat-card-title>
    <p8-layout-settings-header [titlePath]="['Aide']" [iconRacine]="'help'"></p8-layout-settings-header>
  </mat-card-title>
  <mat-card-content>
    <mat-expansion-panel expanded="false">
      <mat-expansion-panel-header>Modèles de pièces à joindre à votre DAR</mat-expansion-panel-header>
      <app-model-pj-view></app-model-pj-view>
    </mat-expansion-panel>
  </mat-card-content>
  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>Circuit d'une DAR</mat-expansion-panel-header>
    <div class="head" fxLayout="row" fxLayoutAlign="end"><button mat-raised-button color="primary" (click)="exportToPdf()">Télécharger la version PDF</button></div>
    <mat-card-content id="help_content">
      <div class="circuit_content">
        <mat-grid-list cols="3" rowHeight="100px" *ngFor="let item of helpCircuitContent">
          <mat-grid-tile [colspan]="3" [rowspan]="1" *ngIf="item.title">
            <div class="title">{{item.title}}</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1" >
            <div class="left_content" [innerHTML]="item.left_content"></div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2" [rowspan]="1">
            <div class="right_content" [innerHTML]="item.right_content"></div>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </mat-card-content>
  </mat-expansion-panel>
</mat-card>
